
const STATUS = {
  SUCCESS: 0, // 请求成功
  ADMIN_ACCOUNT_ERROR: 1111, // 超管账号错误
  PARAMETER_ERROR: 2001, // 参数错误
  SERVER_ERROR: 2002, // 服务繁忙
  PARAMETER_MISSING_ERROR: 2003, // 必填参数缺失
  AUTH_ERROR: 2004, // 没有请求权限
  SAVE_ERROR: 2005, // 保存失败
  SIGN_SUCCESS: 2006, // 签约成功
  SIGN_ERROR: 2007, // 签约失败
  NO_WALLET_ERROR: 2008, // 未绑定钱包
  GATEWAY_AUTH_ERROR: 50101, // 没有请求权限(网关层)
};
export const STATUS_NAME = {
  0: '请求成功',
  2001: '参数错误',
  2002: '必填参数缺失',
  2003: '服务繁忙',
  2004: '没有请求权限',
  2005: '数据保存失败',
  2006: '签约成功',
  2007: '签约失败',
  2008: '当前账号未绑定钱包，请联系客服或商务人员',
  50101: '没有请求权限',
};
export const CONFIRM_BILL_STATUS = {
  NO_NEED: -1,
  UNCONFIRMED: 0,
  CONFIRMED: 1,
};
export const CONFIRM_BILL_STATUS_NAME = {
  [CONFIRM_BILL_STATUS.NO_NEED]: '已经转入',
  [CONFIRM_BILL_STATUS.UNCONFIRMED]: '待转入',
  [CONFIRM_BILL_STATUS.CONFIRMED]: '已转入',
};

export default STATUS;
